import isEmpty from 'lodash/isEmpty';
import { HEADER_BACKGROUNDS } from './constants';
import { getSeasonalHeaderContent } from '../../utils';

const getBoundedIndex = (imageIndex) => imageIndex % HEADER_BACKGROUNDS.length;

/**
 * @returns [Object: {
 *  images: [Array],
 *  attribution: [String]},
 *  Optional >
 *   shouldShowCustomHeader: [Boolean],
 *   customContentTitle: [String],
 *   customContentCtaLabel: [String],
 *   customContentCtaLink: [String],
 *   customContentCtaPrefix: [String],
 * ]
 */
export const getHeaderContent = ({
    seasonalContent,
    tld,
    locationSlug,
    fixedImageIndex = 0,
} = {}) => {
    let response;

    // Right now there is no non-English content available
    response = getSeasonalHeaderContent(seasonalContent, tld, locationSlug);

    if (isEmpty(response)) {
        const imageIndex = fixedImageIndex;

        if (imageIndex >= 0) {
            const boundedImageIndex = getBoundedIndex(imageIndex);

            response = HEADER_BACKGROUNDS[boundedImageIndex];
        }
    }

    return response;
};
